import SortableJsonKeyValueWidget from './SortableJsonKeyValueWidget';


export default SortableJsonKeyValueWidget;
